import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import parseHtml from "html-react-parser";
import React from "react";

import { Card } from "../card/Card";
import SingleCheckbox from "../InputFields/SingleCheckbox";

interface Props {
  fields: Record<string, Field<string>>;
  onUpdateAcceptCheckbox: (accepted: boolean, acceptedTerms: string) => void;
  offerIsAccepted?: boolean;
  propertyNameOverride?: string;
}

export const ClientCheckList = ({ fields, onUpdateAcceptCheckbox, offerIsAccepted }: Props) => (
  <Card>
    <h2>
      <Text field={fields.HeadingClientCheckList} />
    </h2>
    {parseHtml(fields.DescriptionClientCheckList.value)}
    <div className="form-row-divider"></div>
    <SingleCheckbox
      fieldData={fields}
      onChange={(e: boolean) => onUpdateAcceptCheckbox(e, fields.CleanDescriptionClientCheckList.value)}
      value={offerIsAccepted}
      name="AcceptCheckbox"
      fieldName="AcceptCheckbox"
      required
    />
  </Card>
);
